import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	sharedItems: {
		id: 'spa-apps-sidebar-global-settings-system.menu.shared.shared-items',
		defaultMessage: 'Shared Items',
		description: 'Navigation group heading for shared items settings items',
	},
	sharedFilters: {
		id: 'spa-apps-sidebar-global-settings-system.menu.shared.shared-filters',
		defaultMessage: 'Shared filters',
		description: 'Navigation item which links to a shared filters settings page',
	},
	sharedDashboards: {
		id: 'spa-apps-sidebar-global-settings-system.menu.shared.shared-dashboards',
		defaultMessage: 'Shared dashboards',
		description: 'Navigation item which links to a shared dashboards settings page',
	},
	filters: {
		id: 'spa-apps-sidebar-global-settings-system.menu.shared.filters',
		defaultMessage: 'Filters',
		description: 'Navigation item which links to a shared filters settings page',
	},
	dashboards: {
		id: 'spa-apps-sidebar-global-settings-system.menu.shared.dashboards',
		defaultMessage: 'Dashboards',
		description: 'Navigation item which links to a shared dashboards settings page',
	},
});
